import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useEffect } from 'react';
import { MealItemMdfExclModalExclusions } from './containers/MealItemMdfExclModalExclusions/MealItemMdfExclModalExclusions';
import { MealItemMdfExclModalModifiers } from './containers/MealItemMdfExclModalModifiers/MealItemMdfExclModalModifiers';
import { mealItemMdfExclModalStore } from './store/MealItemMdfExclModalStore';
import { IMealItemMdfExclModal } from './types/MealItemMdfExclModal';
import { localeStore } from '~/mobx/localesStore';
import CustomModalComponent from '~/view/components/Controls/Modal/Modal';
import ModalBackground from '~/view/components/Controls/Modal/ModalBackground/ModalBackground';
import ModalContent from '~/view/components/Controls/Modal/ModalContent/ModalContent';
import ModalHeader from '~/view/components/Controls/Modal/ModalHeader/ModalHeader';
import './style.scss';

export const MealItemMdfExclModal: FC<IMealItemMdfExclModal> = memo(
  observer((props: IMealItemMdfExclModal): ReactElement => {
    useEffect(() => {
      mealItemMdfExclModalStore.initStore(props);
    }, []);

    return (
      <CustomModalComponent isOpen className="meal-item-mdf-excl-modal" onRequestClose={mealItemMdfExclModalStore.onCloseModal} withCloseIcon>
        <ModalBackground>
          <ModalHeader title={localeStore.t('cm_config_page_show_modifiers_and_exclusions_popup_header')} />
          <ModalContent scrollSize="small" className="meal-item-mdf-excl-modal__content">
            <MealItemMdfExclModalModifiers />
            <MealItemMdfExclModalExclusions />
          </ModalContent>
        </ModalBackground>
      </CustomModalComponent>
    );
  })
);
